import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormDiamond: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-diamond, square-45-degrees"><path d="M10.0553 2.38404C11.1292 1.3103 12.8701 1.3103 13.944 2.38404L21.6159 10.0559C22.6892 11.1298 22.6895 12.8708 21.6159 13.9446L13.944 21.6165C12.8702 22.6901 11.1292 22.6898 10.0553 21.6165L2.38343 13.9446C1.30969 12.8707 1.30969 11.1298 2.38343 10.0559L10.0553 2.38404Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFormDiamond;
